module.exports = __webpack_public_path__ + "media/images/icons/icon_twitter_login-8bb1b4e141b479563e661333067ac4b9.svg";